import styled from 'styled-components';

export const AppWrapper = styled.section`
    transition: all .3s;
    background-color: ${props => props.showMenu ? '#000000' : '#ffffff'};
`;

